import styled from '@emotion/styled';
import { colors, brandNeutralColors } from '@anyroad/theme';

export const WaiverContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError: boolean;
}>`
  display: flex;
  flex-direction: column;
`;

export const WaiverCheckbox = styled.div<{ hasError: boolean }>`
  display: flex;
  align-items: flex-start;
  padding: 12px 0;
  border: ${(props) => (props.hasError ? `1px solid ${colors.error}` : 'none')};
  border-left-width: ${(props) => (props.hasError ? '5px' : '1px')};
  padding-left: ${(props) => (props.hasError ? '7px' : '0')};
  background-color: ${brandNeutralColors.white};

  &:hover {
    border-color: ${(props) =>
      props.hasError ? colors.error : brandNeutralColors.borderAction};
  }

  &:focus-within {
    border-color: ${brandNeutralColors.borderAction};
    box-shadow: 0 0 0 3px ${brandNeutralColors.borderAction}20;
  }
`;

export const CheckboxWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 0;
`;

export const WaiverContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const WaiverText = styled.div`
  font-size: 14px;
  color: ${brandNeutralColors.text.primary};
  line-height: 1.4;
`;

export const WaiverLink = styled.span`
  color: ${brandNeutralColors.text.primary};
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    color: ${brandNeutralColors.text.primary};
    text-decoration: none;
  }
`;

export const WaiverSubtext = styled.div`
  font-size: 13px;
  color: ${brandNeutralColors.text.secondary};
  line-height: 1.4;
  margin-top: 4px;

  a {
    color: ${brandNeutralColors.text.primary};
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const ErrorMessage = styled.div`
  display: block;
  color: ${brandNeutralColors.white};
  background-color: ${colors.error};
  font-size: 14px;
  line-height: 1.4;
  padding: 10px;
`;
